import ko4oa34 from '../../../assets/temp/subtitles/ko4oa34.vtt';
import ko4ob6n from '../../../assets/temp/subtitles/ko4ob6n.vtt';
import ko4ob6o from '../../../assets/temp/subtitles/ko4ob6o.vtt';
import ko3zdqnSK from '../../../assets/temp/subtitles/ko3zdqn_SK.vtt';
import ko3zdqnEN from '../../../assets/temp/subtitles/ko3zdqn_EN.vtt';
import ko3zxotSK from '../../../assets/temp/subtitles/ko3zxot_SK.vtt';
import ko3zxotEN from '../../../assets/temp/subtitles/ko3zxot_EN.vtt';
import ko3zxouSK from '../../../assets/temp/subtitles/ko3zxou_SK.vtt';
import ko3zxouEN from '../../../assets/temp/subtitles/ko3zxou_EN.vtt';
import ko3zxovSK from '../../../assets/temp/subtitles/ko3zxov_SK.vtt';
import ko3zxovEN from '../../../assets/temp/subtitles/ko3zxov_EN.vtt';
import ko4hbgbSK from '../../../assets/temp/subtitles/ko4hbgb_SK.vtt';
import ko4hbgbEN from '../../../assets/temp/subtitles/ko4hbgb_EN.vtt';
import ko4jn5bSK from '../../../assets/temp/subtitles/ko4jn5b_SK.vtt';
import ko4jn5bEN from '../../../assets/temp/subtitles/ko4jn5b_EN.vtt';
import ko4nb8cSK from '../../../assets/temp/subtitles/ko4nb8c_SK.vtt';
import ko4nb8cEN from '../../../assets/temp/subtitles/ko4nb8c_EN.vtt';
import ko4nenoSK from '../../../assets/temp/subtitles/ko4neno_SK.vtt';
import ko4nenoEN from '../../../assets/temp/subtitles/ko4neno_EN.vtt';
import ko4ng0sSK from '../../../assets/temp/subtitles/ko4ng0s_SK.vtt';
import ko4ng0sEN from '../../../assets/temp/subtitles/ko4ng0s_EN.vtt';

import ko4ng0tEN from '../../../assets/temp/subtitles/ko4ng0t_EN.vtt';
import ko4nqktSK from '../../../assets/temp/subtitles/ko4nqkt_SK.vtt';
import ko4nqktEN from '../../../assets/temp/subtitles/ko4nqkt_EN.vtt';
import ko4o4ijEN from '../../../assets/temp/subtitles/ko4o4ij_EN.vtt';
import ko4o4ijSK from '../../../assets/temp/subtitles/ko4o4ij_SK.vtt';
import ko4oa2rEN from '../../../assets/temp/subtitles/ko4oa2r_EN.vtt';
import ko4oa2rSK from '../../../assets/temp/subtitles/ko4oa2r_SK.vtt';
import ko42okxSK from '../../../assets/temp/subtitles/ko42okx_SK.vtt';
import ko42okxEN from '../../../assets/temp/subtitles/ko42okx_EN.vtt';
import ko42p9vSK from '../../../assets/temp/subtitles/ko42p9v_SK.vtt';
import ko42p9vEN from '../../../assets/temp/subtitles/ko42p9v_EN.vtt';
import ko4306cSK from '../../../assets/temp/subtitles/ko4306c_SK.vtt';
import ko4306cEN from '../../../assets/temp/subtitles/ko4306c_EN.vtt';
import ko4p7yoSK from '../../../assets/temp/subtitles/ko4p7yo_sk.vtt';

import ko4p80nSK from '../../../assets/temp/subtitles/ko4p80n_sk.vtt';
import ko4p80oSK from '../../../assets/temp/subtitles/ko4p80o_sk.vtt';
import ko4p80ySK from '../../../assets/temp/subtitles/ko4p80y_sk.vtt';
import ko4p80pSK from '../../../assets/temp/subtitles/ko4p80p_sk.vtt';

// --------- 1.2.2024

import ko4pehaSK from '../../../assets/temp/subtitles/ko4peha_SK.vtt';
import ko4peaoSK from '../../../assets/temp/subtitles/ko4peao_SK.vtt';
import ko4peanSK from '../../../assets/temp/subtitles/ko4pean_SK.vtt';
import ko4peajSK from '../../../assets/temp/subtitles/ko4peaj_SK.vtt';
import ko4peaiSK from '../../../assets/temp/subtitles/ko4peai_SK.vtt';
import ko4peagSK from '../../../assets/temp/subtitles/ko4peag_SK.vtt';
import ko4peaeSK from '../../../assets/temp/subtitles/ko4peae_SK.vtt';
import ko4pdtdSK from '../../../assets/temp/subtitles/ko4pdtd_SK.vtt';
import ko4pdtdEN from '../../../assets/temp/subtitles/ko4pdtd_EN.vtt';
import ko4pdtcSK from '../../../assets/temp/subtitles/ko4pdtc_SK.vtt';
import ko4pdtcEN from '../../../assets/temp/subtitles/ko4pdtc_EN.vtt';
import ko4p80yEN from '../../../assets/temp/subtitles/ko4p80y_EN.vtt';
import ko4p80pEN from '../../../assets/temp/subtitles/ko4p80p_EN.vtt';
import ko4p80oEN from '../../../assets/temp/subtitles/ko4p80o_EN.vtt';
import ko4p80nEN from '../../../assets/temp/subtitles/ko4p80n_EN.vtt';
import ko4p7yoEN from '../../../assets/temp/subtitles/ko4p7yo_EN.vtt';

// ------- 8.2.2024
import ko4pelcEN from '../../../assets/temp/subtitles/8022024/ko4pelc_EN.vtt';
import ko4pelcSK from '../../../assets/temp/subtitles/8022024/ko4pelc_SK.vtt';
import ko4peldSK from '../../../assets/temp/subtitles/8022024/ko4peld_SK.vtt';
import ko4peleSK from '../../../assets/temp/subtitles/8022024/ko4pele_SK.vtt';
import ko4pelfSK from '../../../assets/temp/subtitles/8022024/ko4pelf_SK.vtt';
import ko4pelgEN from '../../../assets/temp/subtitles/8022024/ko4pelg_EN.vtt';
import ko4pelgSK from '../../../assets/temp/subtitles/8022024/ko4pelg_SK.vtt';
import ko4pelmSK from '../../../assets/temp/subtitles/8022024/ko4pelm_SK.vtt';
import ko4pelnSK from '../../../assets/temp/subtitles/8022024/ko4peln_SK.vtt';

// ------- 3.4.2024
// t1
import ko4pehbSK from '../../../assets/temp/subtitles/3042024/ko4pehb_SK.vtt';
// t2
import ko4ng0tSK from '../../../assets/temp/subtitles/3042024/ko4ng0t_SK.vtt';
// t3
import ko4peaeEN from '../../../assets/temp/subtitles/3042024/ko4peae_EN.vtt';
import ko4peagEN from '../../../assets/temp/subtitles/3042024/ko4peag_EN.vtt';
import ko4peajEN from '../../../assets/temp/subtitles/3042024/ko4peaj_EN.vtt';
import ko4peanEN from '../../../assets/temp/subtitles/3042024/ko4pean_EN.vtt';
import ko4peaoEN from '../../../assets/temp/subtitles/3042024/ko4peao_EN.vtt';
import ko4pehaEN from '../../../assets/temp/subtitles/3042024/ko4peha_EN.vtt';
import ko4pehbEN from '../../../assets/temp/subtitles/3042024/ko4pehb_EN.vtt';
import ko4peldEN from '../../../assets/temp/subtitles/3042024/ko4peld_EN.vtt';
import ko4pelmEN from '../../../assets/temp/subtitles/3042024/ko4pelm_EN.vtt';
// t4
import ko4peleEN from '../../../assets/temp/subtitles/3042024/ko4pele_EN.vtt';
import ko4pelfEN from '../../../assets/temp/subtitles/3042024/ko4pelf_EN.vtt';
import ko4pelnEN from '../../../assets/temp/subtitles/3042024/ko4peln_EN.vtt';
import ko4pfc8SK from '../../../assets/temp/subtitles/3042024/ko4pfc8_SK.vtt';
import ko4pfc9SK from '../../../assets/temp/subtitles/3042024/ko4pfc9_SK.vtt';
import ko4pfccSK from '../../../assets/temp/subtitles/3042024/ko4pfcc_SK.vtt';
// t5
import ko4peaiEN from '../../../assets/temp/subtitles/27052024/ko4peai_EN.vtt';

export function getTracks(id) {
  switch (id) {
    case 'cair-ko4p80n':
      return [
        {
          src: ko4p80nSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4p80nEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4p80o':
      return [
        {
          src: ko4p80oSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4p80oEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4p80y':
      return [
        {
          src: ko4p80ySK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4p80yEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4p80p':
      return [
        {
          src: ko4p80pSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4p80pEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4p7yo':
      return [
        {
          src: ko4p7yoSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4p7yoEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko3zdqn':
      return [
        {
          src: ko3zdqnSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko3zdqnEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko3zxot':
      return [
        {
          src: ko3zxotSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko3zxotEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko3zxou':
      return [
        {
          src: ko3zxouSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko3zxouEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko3zxov':
      return [
        {
          src: ko3zxovSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko3zxovEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4hbgb':
      return [
        {
          src: ko4hbgbSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4hbgbEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4jn5b':
      return [
        {
          src: ko4jn5bSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4jn5bEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4nb8c':
      return [
        {
          src: ko4nb8cSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4nb8cEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4neno':
      return [
        {
          src: ko4nenoSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4nenoEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4ng0s':
      return [
        {
          src: ko4ng0sSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4ng0sEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4ng0t':
      return [
        {
          src: ko4ng0tSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4ng0tEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4nqkt':
      return [
        {
          src: ko4nqktSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4nqktEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4o4ij':
      return [
        {
          src: ko4o4ijSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4o4ijEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4oa2r':
      return [
        {
          src: ko4oa2rSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4oa2rEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko42okx':
      return [
        {
          src: ko42okxSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko42okxEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko42p9v':
      return [
        {
          src: ko42p9vSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko42p9vEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4306c':
      return [
        {
          src: ko4306cSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4306cEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4oa34':
      return [
        {
          src: ko4oa34,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
      ];
    case 'cair-ko4ob6n':
      return [
        {
          src: ko4ob6n,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
      ];
    case 'cair-ko4ob6o':
      return [
        {
          src: ko4ob6o,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
      ];
    // Add more cases for different ids if needed
    // case 'other-id':
    //   return [/* other tracks here */];

    // -------- 1.2.2024

    case 'cair-ko4pehb':
      return [
        {
          src: ko4pehbSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4pehbEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4peha':
      return [
        {
          src: ko4pehaSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4pehaEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4peao':
      return [
        {
          src: ko4peaoSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4peaoEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4pean':
      return [
        {
          src: ko4peanSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4peanEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4peaj':
      return [
        {
          src: ko4peajSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4peajEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4peai':
      return [
        {
          src: ko4peaiSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4peaiEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4peag':
      return [
        {
          src: ko4peagSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4peagEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4peae':
      return [
        {
          src: ko4peaeSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4peaeEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4pdtd':
      return [
        {
          src: ko4pdtdSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4pdtdEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4pdtc':
      return [
        {
          src: ko4pdtcSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4pdtcEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4pelc':
      return [
        {
          src: ko4pelcSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4pelcEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4peld':
      return [
        {
          src: ko4peldSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4peldEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4pele':
      return [
        {
          src: ko4peleSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4peleEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4pelf':
      return [
        {
          src: ko4pelfSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4pelfEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4pelg':
      return [
        {
          src: ko4pelgSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4pelgEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4pelm':
      return [
        {
          src: ko4pelmSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4pelmEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];
    case 'cair-ko4peln':
      return [
        {
          src: ko4pelnSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
        {
          src: ko4pelnEN,
          kind: 'subtitles',
          srcLang: 'EN',
          label: 'English',
          default: false,
        },
      ];

    case 'cair-ko4pfc8':
      return [
        {
          src: ko4pfc8SK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
      ];

    case 'cair-ko4pfc9':
      return [
        {
          src: ko4pfc9SK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
      ];
    case 'cair-ko4pfcc':
      return [
        {
          src: ko4pfccSK,
          kind: 'subtitles',
          srcLang: 'sk',
          label: 'Slovensky',
          default: true,
        },
      ];

    default:
      return [];
  }
}
